"use client";
import React, { useState } from "react";

export const FooterSubscribe = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    console.log("Subscribing email:", email);
  };

  return (
    <section className="w-[362px] max-md:w-full">
      <h2 className="mb-5 text-lg font-semibold text-white">
        Get job notifications
      </h2>
      <p className="mb-10 text-base leading-6 text-zinc-200">
        The latest job news, articles, sent to your inbox weekly.
      </p>
      <form onSubmit={handleSubscribe} className="flex gap-2 max-sm:flex-col">
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="px-4 py-3 text-base text-gray-400 bg-white border border-solid border-zinc-200 w-[223px] max-sm:w-full"
          aria-label="Email Address"
        />
        <button
          type="submit"
          className="px-6 py-3 text-base font-bold text-white bg-indigo-600 cursor-pointer border-[none] hover:bg-indigo-700 transition-colors"
        >
          Subscribe
        </button>
      </form>
    </section>
  );
};
